module.exports = __webpack_public_path__ + "static/img/logo79.25edab5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo79.png
// module id = GFkK
// module chunks = 1